import { TableCellType } from "components/LazyTable";
import SortableTable from "components/SortableTable";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { useIntl } from "react-intl";
import {
  ListRequestOfSkuKnowledgeLevelFilter,
  ListResponseOfSkuKnowledgeLevel,
} from "services/KnowfullyAdminClient";
import { SkuRelatedSkuWithId } from "types/sku-related-types";

const SkuKnowledgeLevels = ({ skuId }: { skuId: string }) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const { data, isFetching } = useStrictQuery<ListResponseOfSkuKnowledgeLevel>(
    ["skuKnowledgeLevels", skuId],
    () =>
      skuService.getSkuKnowledgeLevels(
        skuId,
        ListRequestOfSkuKnowledgeLevelFilter.fromJS({
          sortField: "createdOn",
          sortDescending: true,
        })
      ),
    { enabled: !!skuId }
  );

  const cells: Array<TableCellType> = [
    {
      accessor: "knowledgeLevel.value",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "skuKnowledgeLevelTitle" }),
    },
    {
      accessor: "profession.name",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "professionLabel" }),
    },
  ];

  return (
    <SortableTable
      {...{
        rows: data?.data! as SkuRelatedSkuWithId[],
        loading: isFetching,
        dense: true,
        cells,
        tableRowPerPage: 5,
      }}
    />
  );
};

export default withErrorBoundary(SkuKnowledgeLevels);
